import { convertMetricToFeet } from '../../util';
import { RoofDesignData, RoofFacet } from './type';

export function getRoofDesignData(
	allRoofSegs: RasterRoofSegment[], 
	allRoofEdges: EdgeData[],
	allGutterLines: GutterLine[],
	includeSystemDetectedEdges: boolean,
): RoofDesignData {
	if (!allRoofSegs || allRoofSegs.length === 0) {
		return { facets: [], totalArea: 0, gutterLine: 0 };
	}

	let totalArea = 0;

	const facets = allRoofSegs.map(seg => {
		const areaInSqFt = convertMetricToFeet(seg?.area || 0, 'm2');
		if(!seg.noGapGroundMount){
			totalArea += areaInSqFt;
		}

		const facetInfo: RoofFacet = {
			area: areaInSqFt,
			azimuthDegrees: seg.azimuthDegrees ?? null,
			pitchDegrees: seg.pitchDegrees ?? null,
			roofHeight: seg.roofHeight ?? null,
			label: seg.label,
			id: seg.id,
			coords: seg.simplifiedHullCoords,
		};

		if(seg.isGroundMount){
			facetInfo.isGroundMount = seg.isGroundMount;
		}
		return facetInfo;
	});

	const gutterLineLength = allGutterLines.reduce((sum, gl) => sum + (gl.length ?? 0), 0);

	const specialEdgesLengths= computeSpecialEdgeLengths(allRoofEdges, includeSystemDetectedEdges);
	return {
		facets,
		totalArea,
		gutterLine: convertMetricToFeet(gutterLineLength),
		...specialEdgesLengths
	};
}

function computeSpecialEdgeLengths(allRoofEdges: EdgeData[], includeSystemDetectedEdges:boolean){
	const specialEdges: {[edgeType: string]: number} = {};

	for (const edge of allRoofEdges) {
		if(edge.specialEdge?.isSystemDetected && !includeSystemDetectedEdges) continue;
		const type = edge.specialEdge?.type;
		if (!type) continue;

		const lengthInFeet = convertMetricToFeet(edge.length);
		specialEdges[type] = (specialEdges[type] ?? 0) + lengthInFeet;
	}

	return specialEdges;
}

export function getRoofAttrsData(
	allRoofSegs: RasterRoofSegment[], 
	allGutterLines: GutterLine[],
){
	let totalAreaSqMetric = 0;

	allRoofSegs.forEach(seg => {
		totalAreaSqMetric += (!seg.noGapGroundMount? seg.area ?? 0 : 0);
	});

	const totalGutterLengthMetric = allGutterLines?.reduce((length, gl)=> length +(gl.length ?? 0), 0 );

	return {
		totalGutterlengthLinearFt: convertMetricToFeet(totalGutterLengthMetric),
		totalAreaSqFt: convertMetricToFeet(totalAreaSqMetric, 'm2')
	};
}
